import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { extractProps } from '@radix-ui/themes/helpers';
import { twMerge } from 'tailwind-merge';
import { Flex } from '../layout/index.js';
import { sideNavigationItemsPropDefs } from './side-navigation.props.js';
const SideNavigationItems = forwardRef((props, forwardedRef) => {
    const { side, children, className, ...otherProps } = extractProps(props, sideNavigationItemsPropDefs);
    return (_jsx(Flex, { ref: forwardedRef, flexGrow: side !== 'bottom' ? '1' : undefined, ...otherProps, className: twMerge('rt-SideNavigationItems', className), children: children }));
});
SideNavigationItems.displayName = 'SideNavigation.Items';
export { SideNavigationItems };
//# sourceMappingURL=side-navigation-items.js.map